import React from "react";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const MessageVerfiMail = () => {
  const navigate = useNavigate();

  return (
    <div>

      <div className="container">
        <div className="row">
          <div
            className="col-md-12 d-flex align-items-center justify-content-center"
            style={{ height: "100vh", width: "100vw" }}
          >
            <div className="text-center">
              <div className="card w-100 p-5">
                <p>Merci de vérifier Votre Compte !!</p>
                <button
                  className="btn-lg rounded-pill"
                  style={{
                    backgroundColor: "rgb(19, 198, 221)",
                    color: "white",
                  }}
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MessageVerfiMail;
